<template>
  <div class="graph">
    <!-- <div v-html="graphData"></div> -->
    <div v-if="graphData !== ''" class="position-relative graph-spinner-wrap"><Spinner/></div>
    <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
        <iframe 
          class="embed-responsive-item w-100" 
          :srcdoc="graphData"
          allowfullscreen>
        </iframe>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/spinner'
export default {
  name: 'GraphDisplay',
  components: {
    Spinner
  },
  data() {
    return {

    }
  },
  mounted () {

  },
  methods: {
  
  },
  computed: {
    graphData: function () {
      return this.$store.state.graphApiResponse
    },
    searchWord () {
      return this.$store.state.textForApiCall  
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">
  iframe {z-index: 112;}
</style>
<style>
  @media (max-width: 991px)  {
    .embed-responsive {
      position: static!important;
      margin-top: 30px;
    }
    .graph-spinner-wrap .v-spinner .v-clip {
      top: 50px;
    }
  }
</style>
